<template>
  <div v-if="branch">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"branch.general.name" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.branch" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"branch.general.description" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.description" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Link set</label>
      </div>
      <div class="field-body">
        <div class="field">
            <div class="control">
                <div class="select">
                    <select v-model="branch.clientLinkSetId">
                        <option v-for="linkSet in linkSets" :key="linkSet.id" :value="linkSet.id">
                            {{linkSet.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <button class="button is-success" @click="save()">{{"branch.general.save" | translate}}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import branchService from "../../../services/branch.service"

  export default {
    name: 'branch-create',
    data() {
      return {
        branch: {},
        linkSets: []
      }
    },
    async mounted() {
        this.linkSets = await clientService.getClientLinkSets();
    },
    methods: {
      async save() {
        this.branch = await branchService.create(this.branch);
        this.$router.push({ name: 'branch-list' });
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/branches/create.vue